import './style.scss';
import './card-media-new.tpl.php';
import { addEllipsis } from '../../../jsPlugins/ellipsis';

jQuery($ => {
  addEllipsis($, '.card-media-new h6');
  addEllipsis($, '.card-media-new .date');
});
